import { jsx as _jsx } from "react/jsx-runtime";
import { useDrop } from 'react-dnd';
import { NativeTypes } from 'react-dnd-html5-backend';
import { Box } from '@design-system/box';
export const Drop = ({ children, greedy = false, height, onDrop, width, }) => {
    const [{ isOver }, dropRef] = useDrop({
        accept: [NativeTypes.FILE],
        collect: (monitor) => ({
            isOver: monitor.isOver({ shallow: true }),
        }),
        drop: (droppedFiles, monitor) => {
            const didDrop = monitor.didDrop();
            if (didDrop && !greedy) {
                return;
            }
            onDrop(droppedFiles);
        },
    });
    return (_jsx(Box, { display: "block", height: height, ref: dropRef, width: width, children: children({ isOver }) }));
};
//# sourceMappingURL=Drop.js.map